export const YoutubeAPIInit = (): void => {
    // 2. This code loads the IFrame Player API code asynchronously.
    const tag = document.createElement('script');

    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag?.parentNode?.insertBefore(tag, firstScriptTag);
};

declare global {
    interface Window {
        onYouTubeIframeAPIReady: () => void;
    }
}

export const YOUTUBE_API_READY_EVENT = 'YoutubeAPIReady';

// Create custom event so it could be used on every component
window.onYouTubeIframeAPIReady = (): void => {
    const youtubeAPIReadyEvent = new CustomEvent(YOUTUBE_API_READY_EVENT);
    window.dispatchEvent(youtubeAPIReadyEvent);
};

const COMMAND = 'command';

// Pause Video
const pauseCommand = {
    event: COMMAND,
    func: 'pauseVideo',
};

const playCommand = {
    event: COMMAND,
    func: 'playVideo',
};


export class YoutubePlayer {
    iframe: HTMLIFrameElement;

    constructor(iframe: HTMLIFrameElement) {
        this.iframe = iframe;
    }

    play(): void {
        this.iframe.contentWindow?.postMessage(
            JSON.stringify(playCommand),
            '*'
        );
    }

    pause(): void {
        this.iframe.contentWindow?.postMessage(
            JSON.stringify(pauseCommand),
            '*'
        );
    }
}
